module.exports = __webpack_public_path__ + "static/media/low_thunder.fea0e50b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/low_thunder.mp3
// module id = 270
// module chunks = 0